module.exports = __webpack_public_path__ + "static/media/Download-1.c96b0d69.svg";